function getFormatPrice(price) {
    return Odigeo.Utils.formatCurrency(Math.abs(price),
        Odigeo._.extend({}, Odigeo.Utils.Currency, {decimalPlaces: 0}));
}

function getRenderData(marker) {
    return Odigeo._.extend({}, marker, {
        isTopChoice: marker.topChoice,
        tooltipPrice: getFormatPrice(marker.price),
    });
}

module.exports = {
    getRenderData,
};
